import React, { useEffect, useState, useRef } from 'react';
import './HeroCarousel.css';

const slides = [
  { id: 1, title: 'Optimize your operations', subtitle: 'Automation & integrations that save time', img: '/banner/h1.jpeg' },
  { id: 3, title: 'Partner for long-term success', subtitle: 'Dedicated support and roadmap planning', img: '/banner/h3.jpeg' },
  { id: 2, title: 'Scale confidently', subtitle: 'Cloud-native infrastructure for predictable growth', img: '/banner/h2.jpeg' },
  { id: 4, title: 'Products people love', subtitle: 'User-centered design, continuous delivery', img: '/banner/h4.jpeg' }
];

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const timerRef = useRef(null);
  const touchStartX = useRef(null);
  const touchDeltaX = useRef(0);

  useEffect(() => {
    if (timerRef.current) clearInterval(timerRef.current);
    if (!paused) {
      timerRef.current = setInterval(() => setIndex((i) => (i + 1) % slides.length), 4500);
    }
    return () => { if (timerRef.current) clearInterval(timerRef.current); };
  }, [paused]);

  function handleTouchStart(e) {
    setPaused(true);
    touchDeltaX.current = 0;
    const t = e.touches && e.touches[0];
    if (t) touchStartX.current = t.clientX;
  }

  function handleTouchMove(e) {
    const t = e.touches && e.touches[0];
    if (!t || touchStartX.current == null) return;
    touchDeltaX.current = t.clientX - touchStartX.current;
  }

  function handleTouchEnd() {
    setPaused(false);
    const dx = touchDeltaX.current || 0;
    const threshold = 40; // px
    if (dx > threshold) {
      // swipe right -> previous
      setIndex((i) => (i - 1 + slides.length) % slides.length);
    } else if (dx < -threshold) {
      // swipe left -> next
      setIndex((i) => (i + 1) % slides.length);
    }
    touchStartX.current = null;
    touchDeltaX.current = 0;
    // restart timer
    if (timerRef.current) { clearInterval(timerRef.current); timerRef.current = setInterval(() => setIndex((j) => (j + 1) % slides.length), 4500); }
  }

  return (
    <div
      className="hc-root"
      aria-roledescription="carousel"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <div className="hc-slides" style={{ transform: `translateX(${index * -100}%)` }}>
        {slides.map((s) => (
          <div key={s.id} className="hc-slide">
            <img src={s.img} alt="" className="hc-img" />
            <div className="hc-overlay">
              <h3>{s.title}</h3>
              <p className="muted">{s.subtitle}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
